import { gql } from '@apollo/client';

export const GET_ARTICLE_GOOD_DEAL_PROCESS = gql`
  query GetArticleGoodDealIaProcess($userId: UUIDv4) {
    articleGoodDealAiProcesses(
      first: 30
      orderBy: createdAt_DESC
      where: { userId: $userId }
    ) {
      article {
        id
      }
      status
      id
      createdAt
      updatedAt
      productTitle
      error
    }
  }
`;
